import React, { Component } from 'react';
import { Button, Grid, withStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { EVENT_ID, QNA_API_URL } from '../../constants';

const styles = (theme) => ({
  chatContent: { width: '100%', height: 'calc(100% - 48px)', overflowY: 'scroll' },
  chatInput: { width: '100%' },
  sendBtn: {
    backgroundColor: '#bfbfbf',
    color: '#ffffff',
    fontWeight: 'bold',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  qnaInput: {
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    fontWeight: '500',
  },
  liveLogo: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      transform: 'translateY(-50px)',
    },
  },
});

class QNA extends Component {
  state = {
    msg: '',
    qnaItem: [],
    afterSendModal: false,
  };

  constructor(props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
    this.sendQNA = this.sendQNA.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    console.log('접속한 채널: ' + this.props.channel);
  }

  handleInput(event) {
    this.setState({ msg: event.target.value });
  }

  sendQNA() {
    // let formData = new FormData();

    if (!sessionStorage.getItem('_in_session')) {
      alert('세션정보가 없습니다.');
      return;
    }

    if (!this.state.msg || this.state.msg.length === 0) {
      alert('질문내용을 입력해주세요.');
      return;
    }

    const userId = sessionStorage.getItem('_in_name');

    console.log(
      `question=${this.state.msg}&answer=&eventId=${EVENT_ID}&channel=${this.props.channel}&userId=${userId}&pgmId=${sessionStorage.getItem(
        '_in_session',
      )}&status=R`,
    );

    fetch(`${QNA_API_URL}/qna/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: `question=${this.state.msg}&answer=&eventId=${EVENT_ID}&channel=${
        this.props.channel
      }&userId=${userId}&pgmId=${sessionStorage.getItem('_in_session')}&status=A`,
    }).then((res) => {
      console.log(res);
      this.setState({ msg: '' });
      this.handleOpen();
    });
  }

  handleOpen = () => {
    this.setState({ afterSendModal: true });
  };

  handleClose = () => {
    this.setState({ afterSendModal: false });
  };

  render() {
    const { classes } = this.props;
    const { msg, afterSendModal } = this.state;
    return (
      <Grid
        container
        spacing={0}
        direction={'row'}
        justifyContent={'space-between'}
        /*alignItems={'flex-end'}*/ style={{ padding: 0, height: '100%' }}
      >
        {/* <div className={classes.chatContent}>
          {this.state.qnaItem.map((item, idx) => {
            return <QNAItem chatData={item} key={idx} />;
          })}
        </div> */}
        <div className={classes.chatInput}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <OutlinedInput
              className={classes.qnaInput}
              fullWidth
              multiline
              rows={5}
              placeholder="발표자를 지정해서 질문해주세요. Please select a speaker and ask."
              value={msg}
              onChange={this.handleInput}
            />
            <Button
              className={classes.sendBtn}
              style={msg.length > 0 ? { backgroundColor: '#377ac6' } : { backgroundColor: '#bfbfbf' }}
              onClick={this.sendQNA}
            >
              전송
            </Button>
          </FormControl>
          <div style={{ fontSize: '0.85rem', marginTop: '10px', color: 'rgba(0, 0, 0, 0.4)' }}>
            Q&A에는 세션에 대한 학술질의만 남겨주시기 바랍니다. 등록, 평점 등의 문의사항은 학회 사무국(070-5014-1347)으로 연락하십시오. In
            the Q&A window, please do not leave messages unrelated to the scientific program.
          </div>
        </div>
        <div
          style={{
            textAlign: 'center',
            width: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            msTransform: 'translateY(-10%)',
            marginTop: '71px',
          }}
        >
          <img src="/images/Logo_sample.jpg" style={{ width: '100%' }} alt={'logo'} />
        </div>
        <Dialog open={afterSendModal} onClose={this.handleClose}>
          <DialogContent>
            <DialogContentText style={{ color: '#3d3d3d' }}>
              질문이 전송되었습니다. <br /> (Your question has been sent.)
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button onClick={this.handleClose} autoFocus style={{ color: '#0d4d96', fontWeight: 'bold' }}>
              Confirm(확인)
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    );
  }
}

export default withStyles(styles)(QNA);
